<style lang="scss" src='./opSensorInventory.scss' scoped></style>
<template src="./opSensorInventory.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import GwExport from '@/components/gwExport/GwExport.vue';
import ApexChart from 'vue-apexcharts';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';
import SensorDetails from '@/views/sensors/details/SensorDetails.vue';
import { mapState } from 'vuex';

import {
    getSensorsInventoryReport,
    getAllCoursesReport,
    getOpenCommFailAlerts
} from '@/api/index';

import i18n from './../../../../i18n';
import MapBlueFlag from '@/assets/img/ic/ic_flag_blue.png';
import MapRedFlag from '@/assets/img/ic/ic_flag_red.png';

let CounterForUpdatesCol = 0;
let CounterForUpdatesStack = 0; 
let CounterForUpdatesPie = 0;
let sensorsArray = [];
let availableSensorsArray = [];
let validSensors = [];

const perPage = 100;
const pdfMaxWidth = 1120;
const chartWidth12 = "1050px";
const chartWidth6 = "500px";
const chartWidth4 = "350px";

const colorsArray = [
                    '#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800',
                    "#63b598", "#ce7d78", "#ea9e70", "#a48a9e", "#c6e1e8", "#648177" ,"#0d5ac1" ,
                    "#f205e6" ,"#1c0365" ,"#14a9ad" ,"#4ca2f9" ,"#a4e43f" ,"#d298e2" ,"#6119d0",
                    "#d2737d" ,"#c0a43c" ,"#f2510e" ,"#651be6" ,"#79806e" ,"#61da5e" ,"#cd2f00" ,
                    "#9348af" ,"#01ac53" ,"#c5a4fb" ,"#996635","#b11573" ,"#4bb473" ,"#75d89e" ,
                    "#2f3f94" ,"#2f7b99" ,"#da967d" ,"#34891f" ,"#b0d87b" ,"#ca4751" ,"#7e50a8" ,
                    "#c4d647" ,"#e0eeb8" ,"#11dec1" ,"#289812" ,"#566ca0" ,"#ffdbe1" ,"#2f1179" ,
                    "#935b6d" ,"#916988" ,"#513d98" ,"#aead3a", "#9e6d71", "#4b5bdc", "#0cd36d",
                    "#250662", "#cb5bea", "#228916", "#ac3e1b", "#df514a", "#539397", "#880977",
                    "#f697c1", "#ba96ce", "#679c9d", "#c6c42c", "#5d2c52", "#48b41b", "#e1cf3b",
                    "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf",
                    "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234",
                    "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158",
                    "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647",
                    "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
                    "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
                    "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#21538e", "#89d534", "#d36647",
                    "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
                    "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
                    "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#9cb64a", "#996c48", "#9ab9b7",
                    "#06e052", "#e3a481", "#0eb621", "#fc458e", "#b2db15", "#aa226d", "#792ed8",
                    "#73872a", "#520d3a", "#cefcb8", "#a5b3d9", "#7d1d85", "#c4fd57", "#f1ae16",
                    "#8fe22a", "#ef6e3c", "#243eeb", "#1dc18", "#dd93fd", "#3f8473", "#e7dbce",
                    "#421f79", "#7a3d93", "#635f6d", "#93f2d7", "#9b5c2a", "#15b9ee", "#0f5997",
                    "#409188", "#911e20", "#1350ce", "#10e5b1", "#fff4d7", "#cb2582", "#ce00be",
                    "#32d5d6", "#17232", "#608572", "#c79bc2", "#00f87c", "#77772a", "#6995ba",
                    "#fc6b57", "#f07815", "#8fd883", "#060e27", "#96e591", "#21d52e", "#d00043",
                    "#b47162", "#1ec227", "#4f0f6f", "#1d1d58", "#947002", "#bde052", "#e08c56",
                    "#28fcfd", "#bb09b", "#36486a", "#d02e29", "#1ae6db", "#3e464c", "#a84a8f",
                    "#911e7e", "#3f16d9", "#0f525f", "#ac7c0a", "#b4c086", "#c9d730", "#30cc49",
                    "#3d6751", "#fb4c03", "#640fc1", "#62c03e", "#d3493a", "#88aa0b", "#406df9",
                    "#615af0", "#4be47", "#2a3434", "#4a543f", "#79bca0", "#a8b8d4", "#00efd4",
                    "#7ad236", "#7260d8", "#1deaa7", "#06f43a", "#823c59", "#e3d94c", "#dc1c06",
                    "#f53b2a", "#b46238", "#2dfff6", "#a82b89", "#1a8011", "#436a9f", "#1a806a",
                    "#4cf09d", "#c188a2", "#67eb4b", "#b308d3", "#fc7e41", "#af3101", "#ff065",
                    "#71b1f4", "#a2f8a5", "#e23dd0", "#d3486d", "#00f7f9", "#474893", "#3cec35",
                    "#1c65cb", "#5d1d0c", "#2d7d2a", "#ff3420", "#5cdd87", "#a259a4", "#e4ac44",
                    "#1bede6", "#8798a4", "#d7790f", "#b2c24f", "#de73c2", "#d70a9c", "#25b67",
                    "#88e9b8", "#c2b0e2", "#86e98f", "#ae90e2", "#1a806b", "#436a9e", "#0ec0ff",
                    "#f812b3", "#b17fc9", "#8d6c2f", "#d3277a", "#2ca1ae", "#9685eb", "#8a96c6",
                    "#dba2e6", "#76fc1b", "#608fa4", "#20f6ba", "#07d7f6", "#dce77a", "#77ecca"
                ];

export default {
    name: 'OpSensorInventory',
    extends: SecurityComponent,
    components: {
        ApexChart,
        VueHtml2pdf,
        GwExport,
        SensorDetails
    },
    data() {
        return {
            chartMaxWidth12: '100%',
            chartMaxWidth6: '100%',
            chartMaxWidth4: '100%',
            stickyData: true,
            pdfName: null,
            loading: false,
            loading_comm_alerts: false,
            courses: [],
            sensors: [],
            availableSensors : [],
            sensorsLength: 0,
            assignedLength: 0,
            availableLength: 0,
            sensorSelected : null,
            column_series: [],
            column_x_cats: [],
            stack_series: [],
            stack_x_cats: [],
            pie_series: [],
            pie_cats: [],
            types_amounts: {},
            status_i18n : {},
            basicColCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            stackedColCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pieCharOpt: {
            },
            pagination: {
                page: 1,
                start: 0,
                end: 0
            },
            pagination2: {
                page: 1,
                start: 0,
                end: 0
            },
            google: {},
            map: {},
            markers: [],
            pdf: {},
        };
    },
    computed: {
        ...mapState(['course']),
        getSensors() {
            return this.sensors;
        },
        getAvailableSensors() {
            return this.availableSensors;
        },
        canGetNextPage(){
            return this.pagination.page * perPage < this.sensorsLength;
        },
        canGetNextPage2(){
            return this.pagination2.page * perPage < this.availableLength;
        },
    },
    methods: {
        getSIMValue(sim) {
            const simValue = this.consts.SIM.find((item) => item.key == sim);
            if (simValue) {
                return simValue.value;
            }
            return '-';
        },

        showSensorDetails(sensor) {
            this.sensorSelected = sensor;
            this.$bvModal.show('md-sensor-details');
        },

        onCloseSensorDetailsModal() {
            this.sensorSelected = null;
        },

        sensorMap() {
            if (validSensors.length > 0) {
                
                if (this.markers.length) {
                    this.markers.forEach((m) => {
                        m.setMap(null);
                    });
                }
                
                let center = {
                    lat: validSensors[0].lat,
                    lng: validSensors[0].lng,
                };
                
                if (validSensors.length > 1) {
                    const features = window.turf.featureCollection(
                        validSensors.map((o) => window.turf.point([o.lat, o.lng])),
                    );
                    const gemetryCenter = window.turf.center(features);
                    if (gemetryCenter.geometry && gemetryCenter.geometry.coordinates) {
                        center = {
                            lat: gemetryCenter.geometry.coordinates[0],
                            lng: gemetryCenter.geometry.coordinates[1],
                        };
                    }
                }

                this.setMap(center, 18);
                
            } else {
                this.initMap();
            }
        },

        async initMap() {

            const mapOptions = {
                mapId: 'setMap',
                zoom: 2,
                center: {
                    lat: 0,
                    lng: 0,
                },
                controlOptions: {
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                },
            };

            this.map = await this.G_initMap(mapOptions);
            this.google = this.consts.Google.MAP;
        },
      
        getRssiIcon(sensor) {
            // eslint-disable-next-line
            return require(`@/assets/img/sensor/${this.G_getRssiIcon(sensor, this.rssiRanges)}`);
        },

        setMap(center, zoom) {
            if (this.map && this.google && this.google.maps) {
                var latlngList = [];
                this.markers = validSensors.map((m) => {

                    latlngList.push(new this.google.maps.LatLng(m.lat, m.lng));

                    const infoWindow = new this.google.maps.InfoWindow({
                        content: `
                            <h5 class='d-flex align-items-center '> ${this.G_getSensorName({sensor: m, lbl: true, code: false})} <img src="${this.getRssiIcon(m)}" class='ic-sensor-signal'>  </h5>
                            <table>
                            <tr>
                            <td class='text-right'>${this.$t('general.status')}: </td>
                            <td class='text-left'>${m.status ? m.status.name : ''}</td>
                            </tr>
                            <tr>
                            <td class='text-right'>${this.$t('sensors.location')}: </td>
                            <td class='text-left'> ${ m.is_golf_course ? this.G_getSensorLocation({ sensor: m }) : this.G_getZoneName({ zone: m.hole })} </td>
                            </tr>
                            <tr>
                            <td class='text-right'>${this.$t('weatherStation.serialNumber')}: </td>
                            <td class='text-left'>${m.serial_number}</td>
                            </tr>
                            <tr>
                            <td class='text-right'>${this.$t('sensors.imeiMeid')}: </td>
                            <td class='text-left'>${m.imei}</td>
                            </tr>
                            <tr>
                            <td class='text-right'>${this.$t('sensors.provisionDate')}: </td>
                            <td class='text-left'>${this.G_formatDate({date: m.provision_date, pretty: true})}</td>
                            </tr>
                            </table>
                            `,
                    });

                    const newMark = new this.google.maps.Marker({
                        infoWindow,
                        sensorId: m.sensor_id,
                        sensor: m,
                        position: m,
                        icon: m.status_id !== this.consts.SensorStatus.CHECK ? MapBlueFlag : MapRedFlag,
                    });
                    
                    newMark.setMap(this.map);
                    
                    newMark.addListener('click', (e) => {
                        //newMark.infoWindow.open(this.map, newMark);
                        this.showSensorDetails(newMark.sensor);
                    });

                    return newMark;
                });

                var bounds = new this.google.maps.LatLngBounds();
                
                latlngList.map((n) => {
                    bounds.extend(n);
                });

                this.map.setCenter(bounds.getCenter());
                this.map.fitBounds(bounds);
                this.map.setZoom(this.map.getZoom() - 1);
                
                if (this.map.getZoom() > 18) {
                    this.map.setZoom(18);
                }

            } else {
                setTimeout(() => {
                    this.setMap(center, zoom);
                }, 10);
            }
        },

        getCsvData(){
            if(sensorsArray.length>0 || availableSensorsArray.length > 0){
                let data = sensorsArray.map((item)=>{
                    let obj = {}
                    obj[i18n.t('sensors.sensor')] = this.G_getSensorName({sensor: item, lbl: false, code: false});
                    obj[i18n.t('general.status')] = i18n.t(item.status.i18n);
                    obj[i18n.t('sensors.lastReading')] = this.G_formatDate({date: (item.last_reading), pretty: true});
                    obj[i18n.t('general.signalStrength')] = (item.rssi == undefined || item.rssi == null) ? '' : item.rssi < 0 ? 
                                            this.G_getMeasurement({ val: item.rssi,
                                                                uom: this.consts.UOM.RSSI,
                                                                addUnit: true, invertUOM: false }) 
                                            : i18n.t('general.invalid');
                    obj[i18n.t('sensorCommand.version')] = item.version;
                    obj[i18n.t('sensors.sim')] = this.getSIMValue(item.sim);
                    obj[i18n.t('facility.facility')] = item.course_name;
                    if(item.is_golf_course){
                        obj[i18n.t('sensors.location')] = item.location_code;
                    }else{
                        obj[i18n.t('sensors.location')] = this.G_getZoneName({zone: item.hole});
                    }
                    obj[i18n.t('sensors.provisionDate')]  = this.G_formatDate({date: (item.provision_date), pretty: false});
                    obj[i18n.t('sensors.imei')] = item.imei;
                    obj[i18n.t('sensors.shippedDate')] = this.G_formatDate({date: (item.shipped_date), pretty: false});

                    return obj
                })

                let data2 = availableSensorsArray.map((item)=>{
                    let obj = {}
                    obj[i18n.t('sensors.sensor')] = this.G_getSensorName({sensor: item, lbl: false, code: false});
                    obj[i18n.t('sensors.imei')] = item.imei;
                    obj[i18n.t('sensors.shippedDate')] = this.G_formatDate({date: (item.shipped_date), pretty: false});

                    return obj;
                })

                return data.concat(data2);
            }
            return [];
        },

        showNextPage(){
            if(this.canGetNextPage){
                this.pagination.page += 1;
                this.pagination.start += perPage;
                let newEnd = this.pagination.end + perPage;
                this.pagination.end = (this.sensorsLength >= newEnd) ? newEnd : this.sensorsLength;
            }
            this.getSensorsByPage();
        },
        
        showPrevPage(){
            if(this.pagination.page > 1){
                this.pagination.page -= 1;
                this.pagination.start -= perPage;
                this.pagination.end = this.pagination.start + perPage - 1;
            }
            this.getSensorsByPage();
        },

        showNextPage2(){
            if(this.canGetNextPage2){
                this.pagination2.page += 1;
                this.pagination2.start += perPage;
                let newEnd = this.pagination2.end + perPage;
                this.pagination2.end = (this.availableLength >= newEnd) ? newEnd : this.availableLength;
            }
            this.getAvailableSensorsByPage();
        },
        
        showPrevPage2(){
            if(this.pagination2.page > 1){
                this.pagination2.page -= 1;
                this.pagination2.start -= perPage;
                this.pagination2.end = this.pagination2.start + perPage - 1;
            }
            this.getAvailableSensorsByPage();
        },

        getSensorsByPage(){
            this.sensors = sensorsArray.slice(this.pagination.start - 1, this.pagination.end);
        },

        getAvailableSensorsByPage(){
            this.availableSensors = availableSensorsArray.slice(this.pagination2.start - 1, this.pagination2.end);
        },

        resetValues() {
            sensorsArray = [];
            availableSensorsArray = [];
            this.sensors = [];
            this.availableSensors = [];
            this.sensorsLength = 0;
            this.assignedLength = 0,
            this.availableLength = 0;
            this.sensorSelected = null;
            this.column_series = [];
            this.column_x_cats = [];
            this.stack_series = [];
            this.stack_x_cats = [];
            this.pie_series = [];
            this.pie_cats = [];
            this.types_amounts = {},
            this.pagination= {
                page: 1,
                next: false
            };
            this.pagination2= {
                page: 1,
                next: false
            };
        },
        
        exportReport(item){
            this.$refs.sensorInventoryPDF.generatePdf();
        },

        loadData() {
            this.loading = true;
            this.loading_comm_alerts = true;
            this.resetValues();
            this.types_amounts[this.consts.SensorStatus.DEPLOY_PENDING] = 0;
            this.types_amounts[this.consts.SensorStatus.DEPLOYING] = 0;
            this.types_amounts[this.consts.SensorStatus.DEPLOYED] = 0;
            this.types_amounts[this.consts.SensorStatus.CHECK] = 0;
            this.types_amounts[this.consts.SensorStatus.DEPLOYING_LOW_RSSI] = 0;
            this.getGraph();
        },

        async getGraph(){
            let apiCall = getAllCoursesReport;
            await apiCall().then((res) => {

                if (res.length > 0) {
                    
                    this.courses = res;
                    this.getSensorsList();

                }
            });
            this.loading = false;
        },

        async getSensorsList(){
            let tempStackChartOptions = this.getStackedColumnsChartOptions();
            let tempPieChartOptions = this.getPieChartOptions();
            
            let apiCall = getSensorsInventoryReport;
            
            await apiCall().then((res) => {
                this.loading = false;
                
                this.sensorsLength = res.assigned.length;
                this.availableLength = res.available.length;

                if (this.sensorsLength > 0) {
                    sensorsArray = res.assigned;

                    this.pagination.start = 1;
                    this.pagination.end = (this.sensorsLength >= perPage) ? perPage : this.sensorsLength;

                    // by course
                    let byCourseData = {};
                    // by version
                    let byVersionData = {};
                    
                    for (var i = 0; i < sensorsArray.length; i++){

                        if(sensorsArray[i].latitude != undefined && sensorsArray[i].latitude != null && 
                            sensorsArray[i].longitude != undefined && sensorsArray[i].longitude != null && 
                            !isNaN(sensorsArray[i].latitude) && !isNaN(sensorsArray[i].longitude)
                        ){
                            if(this.G_validateLatLong(sensorsArray[i].latitude, sensorsArray[i].longitude)){
                                sensorsArray[i].lat = sensorsArray[i].latitude;
                                sensorsArray[i].lng = sensorsArray[i].longitude;
                                validSensors.push(sensorsArray[i]);
                            }
                        }
                        
                        let courseKey = sensorsArray[i].course_id;
                        let status = sensorsArray[i].status;
                        let versionKey = sensorsArray[i].version;
                        
                        if (status != undefined && status != null && !(status.status_id in this.status_i18n)){
                            this.status_i18n[status.status_id] = status;
                        }
                        
                        if(courseKey != undefined && courseKey != null){

                            let course = this.courses.find((t) => t.course_id == courseKey);
                            if(course != undefined && course != null){
                                sensorsArray[i].course_name = course.name;
                                if( (course.facility_type && course.facility_type.is_golf_course) 
                                || !course.facility_type){
                                    sensorsArray[i].is_golf_course = true;
                                }else{
                                    sensorsArray[i].is_golf_course = false;
                                }
                            }else{
                                sensorsArray[i].course_name = '';
                                sensorsArray[i].is_golf_course = true;
                            }

                            if (!(courseKey in byCourseData)){
                                byCourseData[courseKey] = {...this.types_amounts};
                            }

                            byCourseData[courseKey][sensorsArray[i].status_id] += 1;   
                        }else{
                            sensorsArray[i].course_name = null;
                        }

                        if(versionKey!= undefined && versionKey != null){
                            if(!(versionKey in byVersionData)){
                                byVersionData[versionKey] = 0;
                            }

                            byVersionData[versionKey] += 1;
                        }


                    }

                    this.sensorMap();
                    this.getSensorsByPage();

                    // by version data
                    for(const [key, value] of Object.entries(byVersionData)){
                        this.pie_series.push(parseInt(value));
                        this.pie_cats.push(key);
                    }

                    tempPieChartOptions.labels = this.pie_cats;

                    this.pieCharOpt = tempPieChartOptions;
                    

                    // by Course data
                    let tempSeries = {}
                    for (const [key, value] of Object.entries(byCourseData)) {
                        
                        let course = this.courses.find((t) => t.course_id == key);
                        
                        if(course != undefined && course != null){

                            this.stack_x_cats.push(course.name);

                            for (const [k, v] of Object.entries(value)) {
                                if (!(k in tempSeries)){
                                    tempSeries[k] = [];
                                }
                                tempSeries[k].push(v);
                            }

                        }
                    }
                    
                    for(const [key, value] of Object.entries(tempSeries)){
                        
                        const reducer = (accumulator, currentValue) => accumulator + currentValue;

                        if(value.reduce(reducer) == 0){
                            continue;
                        }
                        
                        let i18n_key = this.status_i18n[key] != undefined && this.status_i18n[key] != null ? this.status_i18n[key].i18n : key;
                        let name = i18n.t(i18n_key);
                        
                        this.stack_series.push({'name': name, 'data': value})
                    }
                    tempStackChartOptions.xaxis.categories = this.stack_x_cats;

                }
                this.stackedColCharOpt = tempStackChartOptions;

                if(this.availableLength > 0){
                    availableSensorsArray = res.available;

                    this.pagination2.start = 1;
                    this.pagination2.end = (this.availableLength >= perPage) ? perPage : this.availableLength;
                    this.getAvailableSensorsByPage();
                }

                // communication alerts
                this.getOpenCommunicationAlerts();

            });

            this.loading = false;
        },

        async getOpenCommunicationAlerts() {
            this.loading_comm_alerts = true;
            
            let tempChartOptions = this.getBasicColumnChartOptions();

            let apiCall = getOpenCommFailAlerts;
            
            await apiCall().then((res) => {
                this.loading_comm_alerts = false;    
                
                let byCourse = res.by_course;
                
                if(byCourse.length > 0){

                    let tempSeries = []
                    for (var i = 0; i < byCourse.length; i++) {
                        
                        let key = byCourse[i].course_id;
                        
                        let courseName = key;
                        let course = this.courses.find((t) => t.course_id == key);

                        if(course != undefined && course != null){
                            courseName = course.name;

                            this.column_x_cats.push(courseName);

                            tempSeries.push(byCourse[i].total);
                        }
                    }

                    this.column_series.push({'name': this.$t('sensors.sensors'), 'data': tempSeries})

                    tempChartOptions.xaxis.categories = this.column_x_cats;

                }

            });

            this.basicColCharOpt = tempChartOptions;
            this.loading_comm_alerts = false;
        },

        async beforePDF({ html2pdf, options, pdfContent }){
            let container = this.$refs.reportContainer;
            let currentWidth = container.getBoundingClientRect().width;

            if(currentWidth >= pdfMaxWidth){
                this.chartMaxWidth12 = chartWidth12;
                this.chartMaxWidth6 = chartWidth6;
                this.chartMaxWidth4 = chartWidth4;
            }

            let date = new Date();
            this.pdf.date = moment(date).format("MM-DD-YYYY");
            
            this.stickyData = false;

            await html2pdf().set(options).from(pdfContent).toPdf().save();

            this.chartMaxWidth12 = "100%";
            this.chartMaxWidth6 = "100%";
            this.chartMaxWidth4 = "100%";
            this.stickyData = true;
        },

        getBasicColumnChartOptions() {
            return {
                chart: {
                    type: 'bar',
                    animations: {
                        enabled: false,
                    },
                    stacked: false,

                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesCol != 0) {
                                var elmnt = document.getElementById("location_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesCol;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%'
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val < 5 ? (val).toFixed(1) : Math.round(val)) : 0;
                        },
                    },
                    title: {
                        text: ''
                    },
                    min: 0
                },
                xaxis: {
                    type: 'category',
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return val;
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? val : 0;
                        }
                    }
                },
            }
        },

        getStackedColumnsChartOptions(){
            return {
                chart: {
                    type: 'bar',
                    animations: {
                        enabled: false,
                    },
                    stacked: true,

                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesStack != 0) {
                                var elmnt = document.getElementById("stacked_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesStack;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%'
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val < 5 ? (val).toFixed(1) : Math.round(val)) : 0;
                        },
                    },
                    title: {
                        text: ''
                    },
                    min: 0
                },
                xaxis: {
                    type: 'category',
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return val;
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? val : 0;
                        }
                    }
                },
            }
        },

        getPieChartOptions(){
            return {
                chart: {
                    type: 'pie',
                    animations: {
                        enabled: false,
                    },
                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesPie != 0) {
                                var elmnt = document.getElementById("pie_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesPie;
                        }
                    }
                },
                colors: colorsArray,
                dataLabels: {
                    enabled: true
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                legend: {
                    position: 'bottom'
                }
            }
        },

    },

    created() {
        let date = new Date();
        date = moment(date).format("MM-DD-YYYY");
        this.pdfName = i18n.t('reports.sensorInventory') + ' ' + date;
    },

    async mounted() {
        sensorsArray = [];
        availableSensorsArray = [];
        this.initMap();
        this.loadData();
    },
};

</script>
